import { z } from 'zod';

export const recyclePreviewSchema = z
  .object({
    entity: z.enum(['sales', 'payments', 'products']),
    scope: z.enum(['all', 'selected']),
    search: z.string().max(120).default(''),
    ids: z.array(z.string().uuid()).min(1).max(500).optional(),
    request_key: z.string().uuid(),
  })
  .refine((data) => data.scope !== 'selected' || !!data.ids?.length, {
    message: 'Select at least one item.',
    path: ['ids'],
  });

export const recycleDeletionReasonSchema = z
  .string()
  .trim()
  .min(3, 'Enter at least 3 characters.')
  .max(500, 'Use 500 characters or less.');
